<template>
  <div id="dashboard">
    <div class="block block-rounded">
      <!-- <div class="block-header block-header-default">
        <h3 class="block-title">电表管理</h3>
        <div class="block-options">
          <button
            v-if="addBtn"
            type="button"
            class="btn-block-option add-btn mr-2"
            data-toggle="modal"
            @click="create('add')"
          >
            <i class="fa fa-plus mr-1"></i> 绑定
          </button>
          <button
            type="button"
            class="btn-block-option"
            data-toggle="block-option"
            data-action="fullscreen_toggle"
          >
            <i class="si si-size-fullscreen"></i>
          </button>
        </div>
      </div>-->
      <!-- <div class="block-content block-content-full"> -->
      <div class="dataTables_wrapper dt-bootstrap4 no-footer">
        <div class="row mb-1">
          <div class="col-12 col-md-4 text-center text-md-left">
            <pageSize @changePageSize="changePageSize"></pageSize>
          </div>
          <div class="col-12 col-md-4 text-center text-md-center" v-show="!isMobile">
            <div class="dt-buttons">
              <button
                class="dt-button buttons-copy buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
                tabindex="0"
                aria-controls="DataTables_Table_1"
                data-clipboard-text
                @click="copy()"
                type="button"
                id="copybtn"
              >
                <span>复制</span>
              </button>
              <button
                class="dt-button buttons-csv buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
                @click="exportCSV()"
                type="button"
              >
                <span>导出</span>
              </button>
              <button
                class="dt-button buttons-print btn btn-sm btn-primary mr-2 pding-btn"
                @click="print()"
              >
                <span>打印</span>
              </button>
            </div>
          </div>
          <div class="col-12 col-md-4 text-center text-md-right">
            <div class="dataTables_filter">
              <!-- <select
                    class="custom-select col-1 mr-3"
                    id="device-state"
                    name="device-state"
                    v-model="state"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in meterStatus"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</option>
              </select>-->
              <label>
                <input
                  type="search"
                  class="form-control"
                  placeholder="搜索"
                  v-model="key"
                  @keyup.enter="search()"
                />
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="table-responsive">
              <section ref="print">
                <p class="show-on-print print-title">电表</p>
                <table
                  class="table table-bordered table-striped table-vcenter js-dataTable-full dataTable no-footer"
                >
                  <thead>
                    <tr>
                      <th
                        class="text-center sorting"
                        style="width: 60px; min-width:60px"
                        @click="getList('ID',$event)"
                      >#</th>
                      <!-- <th
                        class="text-left sorting"
                        style="min-width: 150px;"
                        @click="getList('CARPORT_NAME',$event)"
                      >车棚名称</th>-->
                      <th
                        class="text-left sorting"
                        style="min-width:150px;"
                        @click="getList('ELECTRICITY_METER_NAME',$event)"
                      >电表名称</th>
                      <th
                        class="text-left d-md-table-cell sorting"
                        style="min-width:100px;"
                        @click="getList('ELECTRICITY_METER_SN',$event)"
                      >电表串号</th>

                      <!-- <th
                        class="text-left sorting"
                        style="min-width:100px;"
                        @click="getList('ELECTRICITY_METER_MODEL',$event)"
                      >电表型号</th>-->
                      <!-- <th
                        class="text-left sorting"
                        style="min-width: 150px;"
                        @click="getList('CELL_NAME',$event)"
                      >所属小区</th>-->

                      <th
                        class="text-left d-md-table-cell sorting"
                        style="min-width:110px;"
                        @click="getList('PILE_NUM',$event)"
                      >充电桩数量</th>
                      <th
                        class="text-left d-md-table-cell sorting"
                        style="min-width:110px;"
                        @click="getList('PORT_COUNT',$event)"
                      >端口数量</th>
                      <th
                        class="text-left d-xl-table-cell sorting"
                        style="min-width:120px;"
                        @click="getList('LAST_DEGREE',$event)"
                      >电表度数</th>
                      <th
                        class="text-left d-xl-table-cell sorting"
                        style="min-width:175px;"
                        @click="getList('LAST_UPDATE',$event)"
                      >抄表时间</th>
                      <th
                        class="text-center sorting"
                        style="width: 100px;min-width: 100px;"
                        @click="getList('ELECTRICITY_METER_STATE',$event)"
                      >设备状态</th>
                      <th
                        class="text-center d-xl-table-cell sorting"
                        style="width: 100px;min-width:100px;"
                        @click="getList('DEVICE_STATE',$event)"
                      >状态</th>
                      <th
                        class="text-center no-print"
                        style="width: 100px; min-width:100px"
                        v-if="changeBtn||editBtn || stateBtn"
                      >操作</th>
                    </tr>
                  </thead>
                  <tbody v-if="meters.length">
                    <tr v-for="(item, i) in meters" :key="i">
                      <td class="text-center">{{ i + 1 }}</td>
                      <!-- <td class="text-left">{{item.CARPORT_NAME}}</td> -->
                      <td
                        class="text-left"
                      >{{ item.ELECTRICITY_METER_NAME && item.ELECTRICITY_METER_NAME.length>0?item.ELECTRICITY_METER_NAME:'未命名' }}</td>
                      <td class="text-left d-md-table-cell">{{ item.ELECTRICITY_METER_SN }}</td>

                      <!-- <td class="text-left">
                        <div class="text-over" style="width:85px">{{ item.ELECTRICITY_METER_MODEL }}</div>
                      </td>-->
                      <!-- <td class="text-left">{{item.CELL_NAME}}</td> -->

                      <td class="text-left d-md-table-cell">{{ item.PILE_NUM }}</td>
                      <td class="text-left d-md-table-cell">{{ item.PORT_COUNT }}</td>
                      <td
                        class="text-left"
                      >{{ item.LAST_DEGREE ?inputChangeFourDecimal(item.LAST_DEGREE):""}}</td>
                      <td class="text-left">{{item.LAST_UPDATE ?formatTimeG(item.LAST_UPDATE):""}}</td>
                      <td class="text-center">
                        <span
                          class="badge badge-pill"
                          :class="{'badge-success':item.ELECTRICITY_METER_STATE == '1','badge-danger':item.ELECTRICITY_METER_STATE != '1'}"
                        >{{ item.ELECTRICITY_METER_STATE == "1" ? "正常" : "故障" }}</span>
                      </td>
                      <td class="text-center d-xl-table-cell" style="min-width:80px;">
                        <!-- 1在线2离线 -->
                        <span
                          class="badge badge-pill"
                          :class="{'text-success':item.DEVICE_STATE == '1','text-secondary':item.DEVICE_STATE != '1', 'wifiDis': item.DEVICE_STATE != '1'}"
                        >
                          <i class="fa fa-wifi"></i>
                        </span>
                        <span class="wifi-error" v-show="item.DEVICE_STATE != '1'">
                          <i class="fa fa-exclamation-circle"></i>
                        </span>
                        <!-- <span
                          class="badge badge-pill"
                          :class="{'badge-success':item.DEVICE_STATE == '1','badge-danger':item.DEVICE_STATE == '0','badge-secondary':item.DEVICE_STATE == '2'}"
                        >{{ showStatus(item.DEVICE_STATE) }}</span>-->
                      </td>
                      <td class="text-center no-print" v-if="changeBtn||editBtn || stateBtn">
                        <div class="btn-group">
                          <button
                            v-if="changeBtn"
                            type="button"
                            class="btn btn-primary js-tooltip-enabled"
                            title="编辑"
                            data-original-title="Edit"
                            data-toggle="modal"
                            @click="create('changeName',item)"
                          >
                            <i class="fa fa-pencil-alt"></i>
                          </button>
                          <button
                            v-if="editBtn"
                            type="button"
                            class="btn btn-primary js-tooltip-enabled"
                            title="抄表"
                            data-original-title="Edit"
                            data-toggle="modal"
                            @click="create('edit',item)"
                          >
                            <i class="fa fa-cloud-upload-alt"></i>
                          </button>
                          <button
                            v-if="stateBtn"
                            type="button"
                            class="btn btn-primary js-tooltip-enabled"
                            title="解除绑定"
                            data-original-title="Edit"
                            data-toggle="modal"
                            @click="changeStartus(item)"
                          >
                            <i class="fa fa-unlink"></i>
                          </button>
                        </div>
                      </td>
                      <!-- <td class="text-left  d-xl-table-cell">
                          <a
                            :href="'/#/Panel/meterDataReportHistory/' + item.ELECTRICITY_METER_SN"
                          >查看历史度数</a>
                      </td>-->
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td class="text-center" colspan="11">查无数据</td>
                    </tr>
                  </tbody>
                </table>
              </section>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-5 text-center text-md-left" v-show="!isMobile">
            <div class="dataTables_info" role="status" aria-live="polite">
              页数
              <strong>{{ page }}</strong> /
              <strong>{{ totalPage }}</strong>
            </div>
          </div>
          <div class="col-sm-12 col-md-7 text-center text-md-right">
            <div class="dataTables_paginate paging_full_numbers">
              <el-pagination
                v-if="meters && meters.length"
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-size="pageSize"
                :small="isMobile"
                :pager-count="pagerCount"
                :layout="isMobile ? 'prev, pager, next':'total, prev, pager, next'"
                :total="total"
                background
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
      <!-- </div> -->
    </div>
    <!-- 绑定电表、上报读书、编辑电表 -->
    <div
      class="modal fade"
      id="modal-default-normal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-default-normal"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{edit=='add'?'绑定电表':(edit=='edit'?'上报电表读数':'电表信息')}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body pb-1">
            <form class="form-horizontal">
              <div class="form-group" v-show="edit!='edit'">
                <label class="col-sm-12 control-label">
                  电表串号
                  <span class="input-required" v-show="edit=='add'">*</span>
                </label>
                <div class="col-sm-12">
                  <el-select
                    filterable
                    placeholder="请选择"
                    style="width: 100%;"
                    maxlength="30"
                    :disabled="edit=='changeName'"
                    v-model="form.electricityMeterSn"
                    @change="changeElectricityMeterSn()"
                  >
                    <el-option
                      v-for="item in electricityMeterSnList"
                      :key="item.ELECTRICITY_METER_SN"
                      :label="item.ELECTRICITY_METER_SN"
                      :value="item.ELECTRICITY_METER_SN"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-12 control-label">
                  电表名称
                  <span class="input-required" v-show="edit=='add'">*</span>
                </label>
                <div class="col-sm-12">
                  <input
                    :disabled="edit=='edit'"
                    class="form-control"
                    placeholder
                    maxlength="30"
                    v-model="form.electricityMeterName"
                  />
                </div>
              </div>
              <div class="form-group form-group-50" v-show="edit=='add'">
                <label class="col-sm-12 control-label">
                  电表型号
                  <span class="input-required" v-show="edit=='add'">*</span>
                </label>
                <div class="col-sm-12">
                  <input
                    :disabled="edit=='report' || edit==''"
                    class="form-control"
                    placeholder
                    maxlength="30"
                    v-model="form.electricityMeterModel"
                  />
                </div>
              </div>

              <div class="form-group" v-show="edit=='add'">
                <label class="col-sm-12 control-label">
                  所属区域
                  <span class="input-required" v-show="edit=='add'">*</span>
                </label>
                <div class="col-sm-12">
                  <select
                    class="form-control col-sm-4 form-group-b"
                    style="float:left;"
                    @change="provinceSel()"
                    v-model="pro"
                    :disabled="edit==''"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in provinceList"
                      :key="index"
                      :value="item.DISTRICT_CODE"
                    >{{item.DISTRICT_NAME}}</option>
                  </select>
                  <select
                    class="form-control col-sm-4 form-group-b"
                    :disabled="edit==''"
                    style="float:left;"
                    @change="citySel()"
                    v-model="city"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in cityList"
                      :key="index"
                      :value="item.DISTRICT_CODE"
                    >{{item.DISTRICT_NAME}}</option>
                  </select>
                  <select
                    class="form-control col-sm-4 form-group-b"
                    :disabled="edit==''"
                    @change="disSel()"
                    v-model="dis"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in districtList"
                      :key="index"
                      :value="item.DISTRICT_CODE"
                    >{{item.DISTRICT_NAME}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group" v-show="edit!='changeName'">
                <label class="col-sm-12 control-label">
                  小区名称
                  <span class="input-required" v-show="edit=='add'">*</span>
                </label>
                <div class="col-sm-12">
                  <select
                    v-show=" edit!='edit'"
                    :disabled="edit==''"
                    class="form-control col-sm-12"
                    v-model="form.cellId"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in cellList"
                      :key="index"
                      :value="item.CELL_ID"
                    >{{item.CELL_NAME}}</option>
                  </select>

                  <input
                    v-show=" edit=='edit'"
                    class="form-control"
                    placeholder
                    maxlength="30"
                    v-model="cellName"
                    disabled
                  />
                </div>
              </div>
              <!-- <div class="form-group form-group-50" v-show="edit=='report' || edit==''">
                <label class="col-sm-12 control-label">充电桩数量</label>
                <div class="col-sm-12">
                  <input class="form-control" placeholder maxlength="30" v-model="pileNum" disabled />
                </div>
              </div>-->
              <div class="form-group form-group-50" v-show="edit=='edit'  ">
                <label class="col-sm-12 control-label">最后读数(度)</label>
                <div class="col-sm-12">
                  <input
                    class="form-control"
                    placeholder
                    maxlength="30"
                    v-model="form.startDegree"
                    disabled
                  />
                </div>
              </div>
              <!-- <div class="form-group form-group-50" v-show="edit=='edit'">
                <label class="col-sm-12 control-label">抄表时间</label>
                <div class="col-sm-12">
                  <input
                    class="form-control"
                    placeholder
                    maxlength="30"
                    v-model="lastUpdate"
                    disabled
                  />
                </div>
              </div>-->
              <div class="form-group form-group-50" v-show="edit=='edit'">
                <label class="col-sm-12 control-label">
                  上报读数(度)
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <input class="form-control" placeholder maxlength="18" v-model="form.endDegree" />
                </div>
              </div>
              <!-- <div class="form-group form-group-50" v-show="edit=='edit'">
                <label  class="col-sm-12 control-label">设备状态</label>
                <div class="col-sm-12">
                  <select
                    :disabled="edit==''"
                    class="form-control"
                    
                    
                    v-model="form.electricityMeterState"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in meterStatus"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</option>
                  </select>
                </div>
              </div>-->
              <!-- <div class="form-group form-group-50" v-show="edit=='edit'">
                <label  class="col-sm-12 control-label">在线状态</label>
                <div class="col-sm-12">
                  <select
                    :disabled=" edit==''"
                    class="form-control"
                    
                    
                    v-model="form.deviceState"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in deviceStatus"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</option>
                  </select>
                </div>
              </div>-->
              <!-- <div class="form-group" v-show="edit!='edit'">
                <label class="col-sm-12 control-label">备注</label>
                <div class="col-sm-12">
                  <input
                    class="form-control"
                    placeholder
                    maxlength="30"
                    v-model="form.remark"
                    :disabled="edit==''"
                  />
                </div>
              </div>-->
            </form>
          </div>
          <div class="modal-footer modal-footer-right">
            <button type="button" class="btn btn-sm btn-light btn-sm-h" data-dismiss="modal">取消</button>
            <button
              v-if="edit!=''"
              type="button"
              class="btn btn-sm btn-primary btn-sm-h"
              @click="submit()"
            >保存</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Util from "../../../Util.js";
import pageSize from "../../../components/pageSize";
export default {
  name: "index",
  data() {
    return {
      meters: [],
      entry: {},
      setToday: new Date(),
      starttime: "",
      endtime: "",
      key: "",
      page: 1,
      size: 10,
      total: 1,
      pageSize: 20,
      selects: [10, 20, 30, 50],
      meterStatus: [
        {
          value: 1,
          label: "正常"
        },
        {
          value: 2,
          label: "故障"
        }
      ],
      deviceStatus: [
        {
          value: 1,
          label: "在线"
        },
        {
          value: 2,
          label: "离线"
        }
      ],
      form: {
        electricityMeterName: "",
        electricityMeterModel: "",
        id: "",
        electricityMeterState: "",
        deviceState: null,
        electricityMeterSn: "",
        startDegree: "",
        endDegree: "",
        remark: "",
        cellId: ""
      },
      pileNum: "",
      provinceList: [],
      cityList: [],
      districtList: [],
      cellList: [],
      electricityMeterSnList: [],
      pro: "",
      city: "",
      dis: "",
      created: false,
      state: "",
      clipboard: null,
      edit: "",
      cellName: "",
      sorting: "",
      orderBy: false,
      lastUpdate: "",
      addBtn: Util.isHavePerm("electricityMeter/saveAddMeter"),
      changeBtn: Util.isHavePerm("electricityMeter/updateMeterName"),
      editBtn: Util.isHavePerm("electricityMeter/saveEditMeter"),
      stateBtn: false //Util.isHavePerm("electricityMeter/unbindMeter")
    };
  },
  components: {
    pageSize
  },
  computed: {
    duration() {
      return this.$store.state.duration;
    },
    roleName() {
      return this.$store.state.roleName;
    },
    totalPage() {
      if (this.total == 0) {
        return 0;
      } else {
        return Math.ceil(this.total / this.pageSize, 1);
      }
    },
    pagerCount() {
      return this.$store.state.pagerCount;
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
    scopeParams() {
      return this.$store.state.scopeParams;
    },
    regionParams() {
      return this.$store.state.regionParams;
    }
  },
  watch: {
    "$store.state.duration": {
      handler: function(val, oldVal) {
        if (typeof oldVal === "undefined") return;
        if (JSON.stringify(val) != JSON.stringify(oldVal)) {
          this.getList();
        }
      },
      immediate: true,
      deep: true
    },
    "form.endDegree"(val, oldVal) {
      this.form.endDegree = Util.inputChangeFourDecimal(val);
    },

    key(val, oldVal) {
      if (val.length == 0) {
        this.getList();
      }
    }
  },
  mounted() {
    if (this.$route.params.scope) {
      this.$store.commit("setParam", {
        scopeParams: this.$route.params
      });
    } else if (this.$route.params.id) {
      this.$store.commit("setParam", {
        scopeParams: {
          scope: "",
          target: ""
        }
      });
    }
    // this.getEntry()
    this.getList();
    this.copy();
  },
  methods: {
    changeElectricityMeterSn() {
      this.electricityMeterSnList.find(item => {
        if (item.ELECTRICITY_METER_SN == this.form.electricityMeterSn) {
          this.form.electricityMeterName = item.ELECTRICITY_METER_NAME;
          this.form.electricityMeterModel = item.ELECTRICITY_METER_MODEL;
        }
      });
    },
    getelectricityMeterSnList() {
      this.$http
        .get(`${Util.searchURL}/Meter/SearchByUseless?key=`)
        .then(res => {
          this.electricityMeterSnList = res.data.data;
        });
    },
    changePageSize(val) {
      this.pageSize = val;
      this.page = 1;
    },
    changeStartus(val) {
      swal("确定解除绑定？", {
        buttons: {
          cancel: {
            text: "取消",
            className: "btn btn-sm btn-light btn-sm-h",
            visible: true
          },
          defeat: {
            text: "确定",
            className: "btn btn-sm btn-primary btn-sm-h"
          }
        }
      }).then(value => {
        switch (value) {
          case "defeat":
            this.switchChange(val);
            break;
        }
      });
    },
    switchChange(val) {
      this.$http
        .post(`${Util.operateURL}/electricityMeter/unbindMeter`, {
          electricityMeterSn: val.ELECTRICITY_METER_SN,
          cellId: val.CELL_ID
        })
        .then(res => {
          if (res.data.code === 200) {
            Util.message("succ", res.data.desc);
            this.getList();
          } else {
            Util.message("err", res.data.desc);
          }
        }),
        err => {
          console.log(err);
        };
    },
    getEntry() {
      this.$http
        .get(`${Util.searchURL}/FlatComplex/Info/${this.$route.params.id}`)
        .then(result => {
          this.entry = result.data.data;
          this.$store.commit("setParam", {
            entry: this.entry
          });
        });
    },
    getList(sorting, that) {
      let params = {};
      if (this.key.length > 0) {
        params["key"] = this.key.trim();
      }
      if (sorting != undefined || this.sorting.length > 0) {
        this.sorting = sorting == undefined ? this.sorting : sorting;
        params["sort"] = this.sorting;
        params["orderBy"] = this.orderBy;

        if (that != undefined && that.currentTarget != undefined) {
          var obj = that.currentTarget;
          if (
            $(obj).is(".sorting_asc") ||
            $(obj).is(".sorting_desc") ||
            $(obj).is(".sorting")
          ) {
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_asc");
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_desc");
            $(obj).addClass(this.orderBy ? "sorting_asc" : "sorting_desc");
            this.orderBy = !this.orderBy;
            params["orderBy"] = this.orderBy;
          }
        }
      }

      this.$http
        .get(
          `${Util.searchURL}/Carport/ListByMeter/${this.page}/${this.pageSize}?region=${this.regionParams.region}&object=${this.regionParams.object}`,
          {
            params: params
          }
        )
        .then(res => {
          if (res.data.code === 200) {
            this.meters = res.data.data.data;
            this.total = res.data.data.pageInfo.total;
          }
        });
    },
    exportCSV() {
      let params = {};
      if (this.key) {
        params["key"] = this.key.trim();
      }
      // params['key'] =  ''
      params["down"] = 1;
      params["sort"] = this.sorting;
      params["orderBy"] = this.orderBy;
      this.$http
        .get(
          `${Util.searchURL}/Carport/ListByMeter/${this.page}/${this.pageSize}?region=${this.regionParams.region}&object=${this.regionParams.object}`,
          {
            params: params,
            responseType: "blob"
          }
        )
        .then(res => {
          if (res.status === 200) {
            Util.ExportCSV(res);
          }
        });
    },
    print() {
      this.$print(this.$refs.print);
    },
    copy() {
      let copyStr = document.getElementsByTagName("section")[1].innerText;
      var btn = document.getElementById("copybtn");
      btn.setAttribute("data-clipboard-text", copyStr);
      this.clipboard = new ClipboardJS(btn);
      this.clipboard.on("success", e => {
        Util.message("succ", "复制成功");
        this.clipboard.destroy();
        e.clearSelection();
      });
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    showStatus(str) {
      switch (str) {
        case "0":
          return "停用";
        case "1":
          return "在线";
        case "2":
          return "离线";
      }
    },
    create(val, id) {
      this.getProvince();
      this.getelectricityMeterSnList();
      jQuery("#modal-default-normal").modal("show");
      this.edit = val;
      if (this.edit == "add") {
        this.form = {
          electricityMeterName: "",
          electricityMeterModel: "",
          id: "",
          electricityMeterState: "",
          deviceState: null,
          electricityMeterSn: "",
          startDegree: "",
          endDegree: "",
          remark: "",
          cellId: ""
        };
        this.cellName = "";
        this.pro = "";
        this.city = "";
        this.dis = "";
      } else {
        this.form = {
          electricityMeterName: id.ELECTRICITY_METER_NAME,
          electricityMeterModel: id.ELECTRICITY_METER_MODEL,
          id: id.ID,
          electricityMeterState: id.ELECTRICITY_METER_STATE,
          deviceState: id.DEVICE_STATE,
          electricityMeterSn: id.ELECTRICITY_METER_SN,
          startDegree: "",
          endDegree: "",
          cellId: id.CELL_ID,
          remark: id.REMARK
        };
        this.pileNum = id.PILE_NUM;
        this.cellName = id.CELL_NAME;
        this.getGetInfo(id.ELECTRICITY_METER_SN);
        Util.displayAreaCell(
          id.CELL_ID,
          this,
          true,
          this.edit == "" ? true : false
        );
      }
    },
    getGetInfo(val) {
      this.$http.get(`${Util.searchURL}/Meter/GetInfo/${val}`).then(res => {
        if (res.data.code === 200) {
          let d = res.data.data;
          this.form.startDegree = this.inputChangeFourDecimal(
            d.LAST_DEGREE || 0
          );
          this.form.remark = d.REMARK;
          this.lastUpdate = d.LAST_UPDATE && Util.formatTimeG(d.LAST_UPDATE);
        }
      });
    },
    modify(id, val) {
      this.created = false;
      this.form = {
        electricityMeterName: val.ELECTRICITY_METER_NAME,
        electricityMeterModel: val.ELECTRICITY_METER_MODEL,
        electricityMeterState: val.ELECTRICITY_METER_STATE,
        id: val.ID,
        electricityMeterSn: val.ELECTRICITY_METER_SN
      };
    },
    submit() {
      let url = "";
      if (this.edit == "add") {
        url = `${Util.operateURL}/electricityMeter/saveAddMeter`;
        this.form.deviceState = "1";
        this.form.electricityMeterState = "1";
      } else if (this.edit == "report") {
        url = `${Util.operateURL}/fran/addMeterOpeDegree`;

        // url = `${Util.operateURL}/electricityMeter/saveEditMeter`;
      } else if (this.edit == "changeName") {
        url = `${Util.operateURL}/electricityMeter/updateMeterName`;
      } else {
        url = `${Util.operateURL}/electricityMeter/saveEditMeter`;
      }
      this.$http.post(url, this.form).then(
        res => {
          if (res.data.code === 200) {
            Util.message("succ", res.data.desc);
            jQuery("#modal-default-normal").modal("hide");
            this.getList();
          } else {
            Util.message("err", res.data.desc);
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    changeTwoDecimal(val) {
      return Util.changeTwoDecimal(val);
    },
    inputChangeFourDecimal(val) {
      return Util.inputChangeFourDecimal(val);
    },
    formatTimeG(val) {
      return Util.formatTimeG(val);
    },
    search() {
      this.page = 1;
      this.getList();
    },
    getProvince() {
      this.$http.get(`${Util.searchURL}/Province/ListByCarportAll`).then(
        res => {
          if (res.data.code === 200) {
            this.provinceList = res.data.data;
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    provinceSel() {
      this.$http
        .get(`${Util.searchURL}/City/ListByCarportProvince/${this.pro}`)
        .then(
          res => {
            if (res.data.code === 200) {
              this.cityList = res.data.data;
              this.city = "";
              this.districtList = [];
              this.dis = "";
              this.cellList = [];
              this.form.cellId = "";
            }
          },
          err => {
            console.log(err);
          }
        );
    },
    citySel() {
      this.$http
        .get(`${Util.searchURL}/District/ListByCarportCity/${this.city}`)
        .then(
          res => {
            if (res.data.code === 200) {
              this.districtList = res.data.data;
              this.dis = "";
              this.cellList = [];
              this.form.cellId = "";
            }
          },
          err => {
            console.log(err);
          }
        );
    },
    disSel() {
      this.$http
        .get(`${Util.searchURL}/FlatComplex/ListByCarportDistrict/${this.dis}`)
        .then(
          res => {
            if (res.data.code === 200) {
              this.cellList = res.data.data;
              this.form.cellId = "";
            }
          },
          err => {
            console.log(err);
          }
        );
    }
  }
};
</script>